export default "__VITE_ASSET__1ke4Hn7B__"